/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var normalizeComponent = require('../../normalize-component-d885d5ff.js');
require('../../regexp-exec-abstract-6e247220.js');
require('../../es.string.search-1012963e.js');
require('../../to-string-e5a81da9.js');

//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'MqSearch',
  data: function data() {
    return {
      search: ''
    };
  },
  props: {
    placeholder: {
      type: String,
      default: 'asset_8'
    }
  },
  mounted: function mounted() {
    this.search = '';
  },
  watch: {
    search: function search() {
      this.$emit('changeValue', this.search);
    },
    $route: function $route(to, from) {
      this.search = '';
    }
  },
  methods: {}
};

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "search" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.trim",
          value: _vm.search,
          expression: "search",
          modifiers: { trim: true },
        },
      ],
      staticClass: "search-input",
      attrs: {
        type: "text",
        placeholder: _vm.$t("" + _vm.placeholder),
        autocomplete: "off",
      },
      domProps: { value: _vm.search },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.search = $event.target.value.trim();
        },
        blur: function ($event) {
          return _vm.$forceUpdate()
        },
      },
    }),
    _vm._v(" "),
    _c(
      "svg",
      {
        staticClass: "icon-search",
        attrs: {
          width: "18",
          height: "18",
          viewBox: "0 0 18 18",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("path", {
          attrs: {
            d: "M14.0257 12.8473L17.5948 16.4157L16.4157 17.5948L12.8473 14.0257C11.5196 15.09 9.86817 15.6689 8.1665 15.6665C4.0265 15.6665 0.666504 12.3065 0.666504 8.1665C0.666504 4.0265 4.0265 0.666504 8.1665 0.666504C12.3065 0.666504 15.6665 4.0265 15.6665 8.1665C15.6689 9.86817 15.09 11.5196 14.0257 12.8473ZM12.354 12.229C13.4116 11.1414 14.0022 9.68353 13.9998 8.1665C13.9998 4.94317 11.389 2.33317 8.1665 2.33317C4.94317 2.33317 2.33317 4.94317 2.33317 8.1665C2.33317 11.389 4.94317 13.9998 8.1665 13.9998C9.68353 14.0022 11.1414 13.4116 12.229 12.354L12.354 12.229Z",
            fill: "#8C8CA2",
          },
        }),
      ]
    ),
    _vm._v(" "),
    _vm.search
      ? _c(
          "svg",
          {
            staticClass: "ficon icon-close",
            attrs: { "aria-hidden": "true" },
            on: {
              click: function ($event) {
                _vm.search = "";
              },
            },
          },
          [_c("use", { attrs: { "xlink:href": "#bf-icon_clossy" } })]
        )
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-73aa5a8a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__.install = function (Vue) {
  Vue.component(__vue_component__.name, __vue_component__);
};

module.exports = __vue_component__;
